import { rootUiActions, rootUiTypes } from 'app-components/flux/root-ui';
import store from 'app-components/utils/redux-store';
import { ImportModalComponent } from 'components/RootModal/modalRegistry';
import { Map as ImmutableMap } from 'immutable';

import type { RequestDialogProps } from './types';

const REQUEST_DIALOG = 'REQUEST_DIALOG';
ImportModalComponent(REQUEST_DIALOG, () => import('./index'));

export const dispatchRequestDialog = (props?: RequestDialogProps) => {
  store?.dispatch(
    rootUiActions.createDialog(
      rootUiTypes.mkRootUiData({
        type: REQUEST_DIALOG,
        props: ImmutableMap(props || {}),
      }),
    ),
  );
};

export default dispatchRequestDialog;
